import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { exchangeCodeForToken } from '../services/authService';

const OAuthCallback: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    if (code) {
      // Exchange code for token via backend
      exchangeCodeForToken(code)
        .then((data) => {
          localStorage.setItem('access_token', data.access_token);
          if (data.email) localStorage.setItem('user_email', data.email);
          navigate('/');
        })
        .catch(() => {
          navigate('/login');
        });
    } else {
      navigate('/login');
    }
  }, [location, navigate]);

  return <div>Authenticating...</div>;
};

export default OAuthCallback; 